export class TrackingResource {
  constructor(
    public readonly name: string,
    public readonly data: any,
  ) {}
}
